import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home.vue'
import { getToken } from '@/utils/auth'
Vue.use(VueRouter)

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/detail',
    name: 'detail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/subjectRecommend/detail.vue')
  },
  {
    path: '/video',
    name: 'video',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/video/index.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/profile/index.vue')
  },
  {
    path: '/project',
    name: 'project',
    component: () => import(/* webpackChunkName: "about" */ '../views/project/index.vue')
  },
  // {
  //   path: '/myUse',
  //   name: 'myUse',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/myUse/index.vue')
  // },
  {
    path: '/mySubject',
    meta: { requiresAuth: true },
    name: 'mySubject',
    component: () => import(/* webpackChunkName: "about" */ '../views/mySubject/index.vue')
  },
  {
    path: '/myOptional',
    name: 'myOptional',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/myOptional/index.vue')
  },
  {
    path: '/allSubject',
    name: 'allSubject',
    component: () => import(/* webpackChunkName: "about" */ '../views/subjectRecommend/allSubject.vue')
  },
  {
    path: '/specialDetail',
    name: 'specialDetail',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/specialSubject/specialDetail.vue')
  },
  {
    path: '/exam',
    name: 'exam',
    component: () => import(/* webpackChunkName: "about" */ '../views/exam/index.vue')
  },
  {
    path: '/questions',
    name: 'questions',
    component: () => import(/* webpackChunkName: "about" */ '../views/questions/questions.vue')
  },
  {
    path: '/subject/center',
    name: 'subjectCenter',
    component: () => import(/* webpackChunkName: "about" */ '../views/subjectCenter/index.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '../views/register/index.vue')
  },
  // 登录页面
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/index.vue')
  },
  // 注意事项
  {
    path: '/attention',
    name: 'Attention',
    component: () => import(/* webpackChunkName: "about" */ '../views/attention/index.vue')
  },
  // 学习流程
  {
    path: '/learningProcess',
    name: 'LearningProcess',
    component: () => import(/* webpackChunkName: "about" */ '../views/learningProcess/index.vue')
  },
  // 问题说明
  {
    path: '/problem',
    name: 'Problem',
    component: () => import(/* webpackChunkName: "about" */ '../views/problem/index.vue')
  },
  // 通知公告详情页面
  {
    path: '/noticeDetail',
    name: 'NoticeDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/noticeDetail/index.vue')
  },
  // 通知公告页面
  {
    path: '/noticeList',
    name: 'NoticeList',
    component: () => import(/* webpackChunkName: "about" */ '../views/noteList/index.vue')
  },
]


const router = new VueRouter({
  mode: 'history',
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  let isAuthenticated = getToken(); // 这里应该是检查用户是否已经登录的逻辑
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    // 如果用户未登录，则重定向到登录页面
    next({ path: '/login' });
  } else {
    // 如果用户已登录，或者不需要登录即可访问，继续导航
    next();
  }
});

// 解决bug：页面/路由跳转后，滚动条消失，页面无法滚动
router.afterEach((to, from, next) => {
  document.querySelector("body").setAttribute("style", "overflow: auto !important;")
});
export default router
